import { trigger, state, style, animate, transition } from '@angular/animations';

const expandedStyle = style({
    paddingTop: '10px',
    height: 'auto',
    paddingBottom: '25px',
});
const collapsedStyle = style({
    paddingTop: '0px',
    height: '0px',
    minHeight: '0',
    paddingBottom: '0px',
    overflow: 'hidden',
    borderWidth: '0px'
});

export const detailExpand = [
    trigger('detailExpand', [
        state('collapsed', collapsedStyle),
        state('expanded', expandedStyle),
        transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        transition('void => expanded', [
            collapsedStyle,
            animate(
                '225ms cubic-bezier(0.4, 0.0, 0.2, 1)',
                expandedStyle
            )
        ]),
        transition('void => collapsed', [
            animate(
                '225ms cubic-bezier(0.4, 0.0, 0.2, 1)',
                collapsedStyle
            )
        ])
    ])
];